export default __webpack_public_path__ + "static/media/truck.5d22b4a7.svg";